// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"a8f3fa34","37":"44763612","76":"5228bbeb","178":"104f28b3","394":"7327c940","453":"c3f52076","462":"eab57f22","648":"9a619c89","700":"457166d5","823":"14fdc97f","842":"f31d7a6f","915":"431a1d0a","918":"84297905","938":"53c4a7af"}[chunkId] + ".chunk.js";
};